// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-bar {
    height: 100vh;
    width: 12vw;
    left: 0;
    top: 0;
}


.side-bar .logo {
  padding-top: 2vh;
}

.menu-container {
  border: 0!important;
  width: 100%!important;
  padding: 1vh 0 !important;
  margin: 0!important;
}

.sidebar-menu-item-container {
  width: 100%;
  border: 0!important;
  padding: 0!important;
  background-color: var(--primary-background)!important;
}

.sidebar-menu-item-container::before {
  height: 0!important;
}

.sidebar-menu-item {
  display: flex!important;
  justify-content: space-between;
  align-items: center;
  padding: 10% 0 !important;
  height: 100%;

}

.sidebar-menu-item.active {
  width: 90%;
  margin-left: 10%;
  background-color: var(--gap-color)!important;
  border-top-left-radius: 40px!important;
  border-bottom-left-radius: 40px!important;
  color: var(--link-active);
}

.sidebar-menu-item.active:before {
  content: "" ;
  position: absolute;
  top: 50%;
  left: 0;
  width: 0.4vw;
  height: 3vh;
  transform: translateY(-50%);
  background-color: var(--link-active);
}

.menu-item-icon {
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-item-text {
  width: 70%;
  justify-content: center;
  align-items: center;
  text-align: start;
  font-family: var(--sidebar-font-family);
}

@media screen and (max-width: 1500px) {
  .menu-item-text {
    display: none;
  }
 
  .menu-item-icon {
    width: 100%;
  }
}


.sidebar-menu-item.active .menu-item-text {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,OAAO;IACP,MAAM;AACV;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;;AAEd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,4CAA4C;EAC5C,sCAAsC;EACtC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE,gBAAgB;AAClB","sourcesContent":[".side-bar {\n    height: 100vh;\n    width: 12vw;\n    left: 0;\n    top: 0;\n}\n\n\n.side-bar .logo {\n  padding-top: 2vh;\n}\n\n.menu-container {\n  border: 0!important;\n  width: 100%!important;\n  padding: 1vh 0 !important;\n  margin: 0!important;\n}\n\n.sidebar-menu-item-container {\n  width: 100%;\n  border: 0!important;\n  padding: 0!important;\n  background-color: var(--primary-background)!important;\n}\n\n.sidebar-menu-item-container::before {\n  height: 0!important;\n}\n\n.sidebar-menu-item {\n  display: flex!important;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10% 0 !important;\n  height: 100%;\n\n}\n\n.sidebar-menu-item.active {\n  width: 90%;\n  margin-left: 10%;\n  background-color: var(--gap-color)!important;\n  border-top-left-radius: 40px!important;\n  border-bottom-left-radius: 40px!important;\n  color: var(--link-active);\n}\n\n.sidebar-menu-item.active:before {\n  content: \"\" ;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 0.4vw;\n  height: 3vh;\n  transform: translateY(-50%);\n  background-color: var(--link-active);\n}\n\n.menu-item-icon {\n  width: 40%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.menu-item-text {\n  width: 70%;\n  justify-content: center;\n  align-items: center;\n  text-align: start;\n  font-family: var(--sidebar-font-family);\n}\n\n@media screen and (max-width: 1500px) {\n  .menu-item-text {\n    display: none;\n  }\n \n  .menu-item-icon {\n    width: 100%;\n  }\n}\n\n\n.sidebar-menu-item.active .menu-item-text {\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
